<template>
  <svg width="1716" height="1716" viewBox="0 0 1716 1716" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M652.674 935.711H964.578V1247.62H1120.53V467.856H964.578V779.76H652.674V467.856H496.723V1247.62H652.674V935.711Z"
      fill="white" />
    <path d="M155.952 155.952H1559.52V1559.52H155.952V155.952ZM0 1715.47H1715.47V0H0V1715.47Z" fill="white" />
    <path d="M1336.03 1091.66H1180.08V1247.62H1336.03V1091.66Z" fill="white" />
  </svg>
</template>
